import { SidebarMenu, SidebarMenuButton, SidebarMenuItem, useSidebar } from "@elit-hair/elit-ui";

import { externalTools } from "./constants";

export const SidebarLinkPanel = () => {
    const { state, isMobile } = useSidebar();
    const collapsed = state === "collapsed" && !isMobile;

    return (
        <SidebarMenu>
            {externalTools.map(({ icon: Icon, label, url }) => (
                <SidebarMenuItem key={label}>
                    <SidebarMenuButton asChild tooltip={collapsed ? label : undefined}>
                        <a href={url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
                            <Icon size={20} style={{ color: "inherit", flexShrink: 0 }} />
                            <span>{label}</span>
                        </a>
                    </SidebarMenuButton>
                </SidebarMenuItem>
            ))}
        </SidebarMenu>
    );
};
